import { memo } from 'react';
import SearchReferencesTaskComponent from './SearchReferencesTaskComponent';
import { StepViewComponentProps } from '../../stepDescriptor/types';

function SearchReferencesPinnedViewComponent(props: StepViewComponentProps) {
  return <SearchReferencesTaskComponent {...props} isPinnable isPinnedView />;
}
export default memo(SearchReferencesPinnedViewComponent);
